import moment from 'moment/moment';
import numeral from 'numeral';

export class NumberKit {
  public static formatNumber = (value: number): string =>
    numeral(value).format('0,0');

  public static formatNumberPrecision1 = (value: number): string =>
    numeral(value).format('0,0.0');

  public static formatMoney = (value: number): string =>
    numeral(value).format('$0,0');

  public static formatMoneyPrecision1 = (value: number): string =>
    numeral(value).format('$0,0.0');

  public static formatPercent = (percent: number | string): string =>
    `${numeral(percent).format('0.0')}%`;

  public static formatToFixed = (number: number): string =>
    `${numeral(number).format('0.0')}`;

  public static formatDate = (dateToFormat: unknown) => {
    if (!dateToFormat) return '--';
    return moment(dateToFormat).calendar(null, {
      sameDay: '[Today]',
      nextDay: '[Tomorrow]',
      nextWeek: 'MMM D',
      lastDay: '[Yesterday]',
      lastWeek: 'MMM D',
      sameElse: 'MMM D',
    });
  };
}
